import { VESSEL_WRITE_DENY_ROLES } from './fleetRouteAccess';

export default [
    {
        path: '/trailers',
        name: 'Trailers',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
            title: 'Trailers',
        },
        components: {
            default: () => import('@views/trailers/TrailerIndex.vue'),
        },
    },
    {
        path: '/trailers/create',
        name: 'TrailerCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: VESSEL_WRITE_DENY_ROLES,
            title: 'Create trailer',
        },
        components: {
            default: () => import('@views/trailers/TrailerCreate.vue'),
        },
    },
    {
        path: '/trailers/:id/edit',
        name: 'TrailerEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: VESSEL_WRITE_DENY_ROLES,
            title: 'Edit trailer',
        },
        components: {
            default: () => import('@views/trailers/TrailerEdit.vue'),
        },
    },
];
